export const selectOptions = [
  { label: 'mongo', value: 'mongo' },
  { label: 'postgres', value: 'postgres' },
]
